import React from 'react';
import '../template-file-css/document-file-template.css';


export const GHP_ClientIntroductionLetter = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GHP_ClientIntroductionLetter' className='file-pdf-document'>
            <div className='file-template'>


                <h3>
                    Introduction to Services</h3>
                <p>
                    Welcome to &nbsp;
                    <span id="compNameSpan"></span>
                    <input type="text" id="compName" name="compName" placeholder='Company Name' className='add-only' />. We are focused on providing professional services for children, adolescents and
                    families.</p>
                <p>
                    As you are aware, we have received a referral to provide services to your child.
                    Authorization for services depends solely on what your insurance will approve. Below
                    is the list of services which have been authorized and the dates of authorization
                    which your insurance has approved.</p>
                <h3>
                    Expectations</h3>
                <p>
                    <span> <b>What can I expect during the course of services?</b> </span>
                    <br />
                    At the onset of services, your child will receive several assessments including
                    a clinical assessment, psychological evaluation, nursing assessment and a psychiatric
                    evaluation.</p>
                <p>
                    Depending upon the services that are authorized by your insurance, your child will
                    be assigned a case manager and/or therapist.</p>
                <p>
                    Regular visits will be made with you and your child to conduct in-home services.
                    The frequency, duration and type of services you receive will be determined by your
                    insurance.</p>
                <p>
                    Your assigned case manager and/or therapist will explain more fully what services
                    you will be receiving and how frequently they will be visiting your home.</p>
                <h3>
                    Active Client Payers (in priority order)</h3>
                <table border={0}>
                    <tr>
                        <td className='w-450'>
                            <span className='eleHeader'>Payer Name</span>
                        </td>
                        <td className='w-300'>
                            <span className='eleHeader'>Active Date</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='text' id="txtPayerName1" name="txtPayerName1" className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='date' id="dtActiveDate1" name="dtActiveDate1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='text' id="txtPayerName2" name="txtPayerName2" className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='date' id="dtActiveDate2" name="dtActiveDate2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'>
                            <input type='text' id="txtPayerName3" name="txtPayerName3" className='add-only' />
                        </td>
                        <td className='w-300'>
                            <input type='date' id="dtActiveDate3" name="dtActiveDate3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Current Staff Assignments</h3>
                <table border={0}>
                    <tr>
                        <td className='w-200'>Name</td>
                        <td className='w-400'>Role</td>
                        <td className='w-150'>Start Date</td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtStaffAssignments_Name1" name="txtStaffAssignments_Name1" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id="txtStaffAssignments_Role1" name="txtStaffAssignments_Role1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id="dtStaffAssignments_StartDate1" name="dtStaffAssignments_StartDate1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtStaffAssignments_Name2" name="txtStaffAssignments_Name2" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id="txtStaffAssignments_Role2" name="txtStaffAssignments_Role2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id="dtStaffAssignment_StartDate2" name="dtStaffAssignment_StartDate2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='text' id="txtStaffAssignments_Name3" name="txtStaffAssignments_Name3" className='add-only' />
                        </td>
                        <td className='w-400'>
                            <input type='text' id="txtStaffAssignments_Role3" name="txtStaffAssignments_Role3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id="dtStaffAssignments_StartDate3" name="dtStaffAssignments_StartDate3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Authorized Services</h3>
                <table border={0}>
                    <tr>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Behavior Health Assessment" /> Behavior Health Assessment
                        </td>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Community Transition" /> Community Transition
                        </td>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Crisis Intervention" /> Crisis Intervention
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Community Support Individual (CSI)" /> Community Support Individual (CSI)
                        </td>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Individual Services - Counseling & Skill Building" /> Individual Services - Counseling &amp; Skill Building
                        </td>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Family Services - Counseling & Skill Building" /> Family Services - Counseling &amp; Skill Building
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Group Services" /> Group Services
                        </td>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Intensive Family Intervention - IFI" /> Intensive Family Intervention - IFI
                        </td>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Medication Administration" /> Medication Administration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Nursing Services" /> Nursing Services
                        </td>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Psychiatric Services" /> Psychiatric Services
                        </td>
                        <td className='w-250' >
                            <input type="checkbox" name="chkAuthorizedServices" className="formTextarea dd" value="Psychological Services" />  Psychological Services
                        </td>
                    </tr>
                </table>
                <p>
                    <span> <b>Please Note:</b></span> Although the authorization is for a specified
                    period of time, the insurance approves services for a specific number of sessions.
                    Based on your child's individual needs, the sessions may be exhausted prior to the
                    end of the authorization period.</p>
                <h3>Authorization Dates</h3>
                <table>
                    <tr>
                        <td className='w-375' >
                            <span className='eleHeader'>From:</span>
                            <input type='text' id="dtAuthorizationFrom" name="dtAuthorizationFrom" className='add-only' />
                        </td>
                        <td className='w-375' >
                            <span className='eleHeader'>To:</span>
                            <input type='text' id="dtAuthorizationTo" name="dtAuthorizationTo" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>
                    Frequently Asked Questions</h3>
                <p>
                    <span> <b>1) What ages qualify for services?</b></span><br />
                    Children between the ages of 4 and 21.</p>
                <p>
                    <span> <b>2) What are CORE services?</b></span><br />
                    CORE services are Medicaid funded services for children and adolescents who are exhibiting mental health issues. CORE service provides a comprehensive model for the purpose of prevention and intervention to avoid out of home placement.</p>
                <p>
                    <span> <b>3) What is the difference between an Assessor, Case Manager and Therapist?</b></span><br />
                    Question 3:
                    What is the difference between an Assessor, Case Manager and Therapist?

                    The assessor is a Master's Level, unlicensed staff member who compiles information regarding aspects of the consumer's and family history and current functioning. The assessor will obtain previous records and current information to make a diagnostic impression, not a formalized diagnosis. Please remember a formalized diagnosis can only be provided by a licensed psychologist or psychiatrist.<br /><br />

                    The Case Manager is directed by the licensed staff for complete wrap around services. The Case Manager is responsible for Family Training and Community Support Individual (Community Linkage and Coping Skills Training), obtaining previous treatment records, and ensuring the completion of the psychological evaluation and nursing evaluation within 30 days of case assignment. The Case Manager is also responsible for school collaboration to assist with enhancement of the consumer's emotional and mental functioning such as IEP attendance and training for school staff for the purpose of promoting safe and healthy consumer interaction.<br /><br />

                    The Therapist is a fully or partially licensed Master's level or Doctoral level staff recognized by the State of Georgia Composite Board. The therapists' role includes individual and family therapy, crisis intervention, monthly staffing facilitation with both the family and referral sources and the supervision of the CORE Case Manager.
                </p>
                <p>
                    <span><b>4) What is a biopsychosocial?</b></span><br />
                    The bio-psychosocial assessment is performed before other therapeutic services are provided. It helps evaluate a child's mental and behavioral issues, genetic history, environment, and global functioning, such as performance and interaction in school, that also helps shape the treatment a child receives.</p>
                <p>
                    <span><b>5) What is a psychological evaluation?</b></span><br />
                    Psychiatric evaluations are conducted by a licensed medical doctor who specializes in psychiatric treatment. Medications are prescribed from this evaluation, if needed, by the psychiatrist. Recommendations are given as part of the medical plan of care to achieve stability.</p>
                <p>
                    <span><b>6) What is a psychiatric evaluation?</b></span><br />
                    sychiatric evaluations are conducted by a licensed medical doctor who specializes in psychiatric treatment. Medications are prescribed from this evaluation, if needed, by the psychiatrist. Recommendations are given as part of the medical plan of care to achieve stability.</p>


            </div>
        </form >
    )
}